import { render } from "./Food-list.vue?vue&type=template&id=3e4285b2&scoped=true"
import script from "./Food-list.vue?vue&type=script&lang=js"
export * from "./Food-list.vue?vue&type=script&lang=js"

import "./Food-list.vue?vue&type=style&index=0&id=3e4285b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4285b2"]])

export default __exports__